import { limitedReleasesListConstants } from "../_redux-constants/";

export function limitedReleasesListReducer(
  state = {
    limitedReleasesListLoading: false,
    limitedReleasesListData: null,
    limitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleasesListConstants.LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        limitedReleasesListLoading: true,
        limitedReleasesListData: null,
        limitedReleasesListError: null,
      });
    case limitedReleasesListConstants.LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        limitedReleasesListLoading: false,
        limitedReleasesListData: action.data,
      });
    case limitedReleasesListConstants.LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        limitedReleasesListLoading: false,
        limitedReleasesListData: null,
        limitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
